import { getDevicePixelRatio } from 'use-device-pixel-ratio'

import { Nil } from '../types'

const SCALED_IMAGE_SERVING_URL_PATTERN =
  /https?:\/\/lh3\.googleusercontent\.com\/.+/

export const getScaledImageOrOriginal = (
  image: string | Nil,
  imageThumbnail: string | Nil,
  longestDimensionSize: number,
) => {
  if (imageThumbnail && SCALED_IMAGE_SERVING_URL_PATTERN.test(imageThumbnail)) {
    const dpr = getDevicePixelRatio({ round: false })
    const targetLongestDimensionSize = Math.ceil(dpr * longestDimensionSize)
    // s<targetLongestDimensionSize> - request image with the longest dimension size equal to targetLongestDimensionSize
    // rw - force the resulting image thumbnail to be WebP
    return `${imageThumbnail}=s${targetLongestDimensionSize}-rw`
  }

  return image || undefined
}
